module.exports = "/build/images/visa-logo-new.png?753f97532f56452666bd9fae54b9a655";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/visa-logo-new.png
// module id = 2420
// module chunks = 0